import React, { memo } from 'react';
import { Controller } from 'react-hook-form';
import { TextField, makeStyles } from '@material-ui/core';
import { COLOR_BORDER } from '../../styles/colors';
import { EvaluationFieldProps } from '../../types/Evaluation';
import Input from '../Input';

const useStyles = makeStyles(theme => ({
  numberField: {
    minWidth: 220,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: COLOR_BORDER,
    },
  },
}), { name: 'NumberInput' });

function NumberInput({ name, control, label }: EvaluationFieldProps) {
  const classes = useStyles();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, ref } }) => (
        <Input 
            type="number"
            className={classes.numberField} 
            label={label}
            value={value || ''}
            onChange={onChange}
            rows={2}
        />
      )}
    />
  );
}

export default memo(NumberInput);
